import styles from "./toolbox-components.module.css";
import { filterClasses } from "PosterEditor/utils/filter-classes";
import { useRef, useEffect, useState } from "react";

interface ToolboxComponentTextareaProps {
  text: string;
  placeholder?: string;
  onChangeText: (text: string) => void;
  className?: string;
  autoFocusOnMount?: boolean;
  variant?: "outlined" | "minimal";
  disabled?: boolean;
  maxLength?: number;
  rows?: number;
}

export const ToolboxComponentTextarea = ({
  text,
  placeholder,
  onChangeText,
  className,
  autoFocusOnMount,
  variant = "outlined",
  disabled = false,
  maxLength,
  rows = 3,
}: ToolboxComponentTextareaProps) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [remainingChars, setRemainingChars] = useState(
    maxLength ? maxLength - text.length : undefined
  );

  useEffect(() => {
    if (autoFocusOnMount && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [autoFocusOnMount]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newText = e.target.value;
    
    if (maxLength && newText.length > maxLength) {
      return;
    }
    
    onChangeText(newText);
    if (maxLength) {
      setRemainingChars(maxLength - newText.length);
    }
  };

  return (
    <div className={styles.textareaContainer}>
      <textarea
        ref={textareaRef}
        className={filterClasses(
          styles.textarea,
          className,
          variant === "outlined" ? styles.textareaOutlined : styles.textareaMinimal,
          disabled ? styles.disabled : ""
        )}
        placeholder={placeholder}
        value={text}
        onChange={handleChange}
        disabled={disabled}
        rows={rows}
      />
      {maxLength && (
        <div className={styles.characterCounter}>
          {remainingChars} characters remaining
        </div>
      )}
    </div>
  );
};